import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
    Button,
    GridRow, GridColumn, Grid,
    Icon, Checkbox,
    Select,
    Header,
    Message, MessageHeader,
    Image,
    Modal, Segment,
    FormTextArea,
    FormSelect,
    FormRadio,
    FormInput,
    FormGroup,
    FormCheckbox,
    FormButton,
    Form, Input,
    Loader,
    Dimmer,
    Item,
    Visibility,
} from 'semantic-ui-react';
var moment = require('moment');
import { withRouter } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';

import { connect } from 'react-redux';
import styled from 'styled-components';
import { InsertCupomDescontoAction, ValidarSenhaAction } from '../../actions/CupomAction';

import React from 'react'
import { getParceirosLista } from '../../utils/API';
import { use } from 'react';



function Relatorio(props) {

    const { cupomDesconto, cupomDescontoLoader, InsertCupomDescontoAction, ValidarSenhaAction, validarSenhaLoader, validarSenha } = props;

    const [opcaoSelecionada, setOpcaoSelecionada] = useState('')
    const [errorPassword, setErrorPassword] = useState(false)

    const [password, setPassword] = useState('')
    const [lembrarSenha, setLembrarSenha] = useState(false)

    console.log("teste senha: ", localStorage.getItem('senhaCupom'));

    useEffect(() => {
        const senhaSalva = localStorage.getItem('senhaCupom');
        const lembrarSenha = localStorage.getItem('lembrarSenha') === 'true';

        setLembrarSenha(lembrarSenha);

        if (lembrarSenha && senhaSalva) {
            setPassword(senhaSalva);
        }
    }, []);


    const handleChange = (value) => {
        setOpcaoSelecionada(value)

        console.log(value)
    }

    const handlePassword = (e, { name, value }) => {
        setPassword(value)

    }

    const enviarCupom = (opcaoEscolhida, senhaValida) => {
        console.log("opt: ", opcaoEscolhida);
        if (!opcaoEscolhida || opcaoEscolhida === '') {
            toast.error(
                <div>
                    <p style={{ margin: 0 }}><b>Campo Obrigatório</b></p>
                    <small>Por favor, selecione o tipo de cupom desejado.</small>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
        } else {
            if (senhaValida) {
                if (lembrarSenha) {
                    localStorage.setItem('senhaCupom', password);
                    localStorage.setItem('lembrarSenha', 'true');
                } else {
                    localStorage.removeItem('senhaCupom');
                    localStorage.setItem('lembrarSenha', 'false');
                }
                InsertCupomDescontoAction(codparc, nomeparc, {
                    opcaoDesconto: opcaoEscolhida
                });
                toast.success(
                    <div>
                        <p style={{ margin: 0 }}><b>Senha Aceita</b></p>
                        <small><b>Cadastro de cupom efetuado com sucesso</b></small><br></br>
                        <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );

            } else {
                toast.error(
                    <div>
                        <p style={{ margin: 0 }}><b>Senha Inválida</b></p>
                    </div>,
                    {
                        position: "top-right",
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            background: "#fff",
                            color: "#000",
                        },
                    }
                );
            }
        }
        if (!codparc) {
            toast.error(
                <div>
                    <p style={{ margin: 0 }}><b>Código do parceiro não identificado</b></p>
                </div>,
                {
                    position: "top-right",
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    draggable: true,
                    progress: undefined,
                    style: {
                        background: "#fff",
                        color: "#000",
                    },
                }
            );
            return;
        }
    }

    const verSenha = () => {
        const inputSenha = document.getElementById('passwordCupom');
        if (inputSenha.type === 'password') {
            inputSenha.type = 'text';
        } else {
            inputSenha.type = 'password';
        }
    }

    const codparcParam = props.match.params.codparc ? props.match.params.codparc : ''
    const nomeparcParam = props.match.params.nomeparc ? props.match.params.nomeparc : ''
    const codparc = codparcParam.match(/^\d+/)?.[0] || null
    const nomeparcPrefixo = codparcParam.replace(/^\d+\s*-?\s*/, '').trim()
    const nomeparc = [nomeparcPrefixo, nomeparcParam].filter(Boolean).join(' - ') || null

    console.log(codparc);


    return (

        <Segment className='container'><ToastContainer />
            <Header className='header'>
                <div className='header_menu'>Cupom</div>
            </Header>

            <div className='content content_codparc'>
                <p>{nomeparc}</p>
                <p>CODPARC: {codparc}</p>
            </div>

            <Form id="formInsert" >
                <Grid style={{ margin: '0em', gap: '2em' }} width={16} className='formCupom'>
                    <GridRow style={{ justifyContent: 'space-between' }} className='formCupomLinhas'>

                        <GridColumn className="content" width={7}>
                            <Form.Field className="campoInputsForm">
                                <label className="label">Cupons</label>
                                <FormRadio
                                    className='inputRadio'
                                    label='Cupom de reativação   (17,99%)'
                                    value='1'
                                    checked={opcaoSelecionada === '1'}
                                    onChange={(e, data) => { handleChange(data.value) }}
                                />
                                <FormRadio
                                    className='inputRadio'
                                    label='Cupom de abertura   (19,99%)'
                                    value='2'
                                    checked={opcaoSelecionada === '2'}
                                    onChange={(e, data) => { handleChange(data.value) }}
                                />
                                <FormRadio
                                    className='inputRadio'
                                    label='Cupom de projeto   (21,99%)'
                                    value='3'
                                    checked={opcaoSelecionada === '3'}
                                    onChange={(e, data) => { handleChange(data.value) }}
                                />
                            </Form.Field>
                        </GridColumn>


                        <GridColumn className="content" width={7}>
                            <Form.Field className="campoInputsForm">
                                <label>Senha:</label>
                                {/* <label style={{display:'none !important'}}
                                    name="username"
                                    autoComplete="username"
                                    placeholder="Usuário"
                                >{nomeparc}</label> */}
                                <div className='boxSenha'>
                                    <Input
                                        fluid
                                        icon='lock'
                                        iconPosition='left'
                                        placeholder='Password'
                                        type='password'
                                        name='passwordCupom'
                                        value={password}
                                        id='passwordCupom'
                                        autoComplete="off"
                                        maxLength={20}
                                        onChange={(e) => {
                                            handlePassword(e, { name: 'passwordCupom', value: e.target.value }),
                                                setPassword(e.target.value)
                                        }}
                                    ></Input>
                                    <Button
                                        className='btnOlharSenha'
                                        type='button'
                                        icon='eye'
                                        basic
                                        color='blue'
                                        onClick={() => { verSenha() }}
                                    >

                                    </Button>
                                </div>
                                <div className='optSalvarSenha'>
                                    <FormCheckbox
                                        checked={lembrarSenha}
                                        onChange={(e, data) => {
                                            setLembrarSenha(data.checked)

                                            if (!data.checked) {
                                                localStorage.removeItem('senhaCupom');
                                                localStorage.setItem('lembrarSenha', 'false');
                                            }
                                        }}
                                        label='Lembrar senha'
                                    />
                                </div>

                                <Button
                                    type='button'
                                    form='formInsert'
                                    disabled={cupomDescontoLoader}
                                    loading={cupomDescontoLoader}
                                    className="btn_enviar"
                                    onClick={() => {
                                        ValidarSenhaAction(codparc, password)
                                            .then((retorno) => {

                                                if (retorno.success) {
                                                    console.log(retorno)

                                                    enviarCupom(opcaoSelecionada, retorno.success)
                                                } else {
                                                    console.log(retorno)

                                                    enviarCupom(opcaoSelecionada, retorno.success)
                                                }

                                            })
                                    }}
                                >Gerar Cupom</Button>
                            </Form.Field>
                        </GridColumn>
                    </GridRow>
                </Grid>
            </Form>


            <style>{`

                .optSalvarSenha{
                    margin-top: .5em !important;
                    //text-align: right !important;
                    
                }
                .optSalvarSenha label{
                    font-size: .9em !important;
                }

                .boxSenha{
                    display: flex !important;
                    width: 100% !important;
                    margin: 0 !important;
                }
                .ui.basic.button.btnOlharSenha{
                    margin: 0 !important;
                    opacity: .8 !important;
                    background-color: rgb(212, 230, 230) !important;
                }      

                .campoInputsForm .label{
                    margin-bottom: .7em !important;
                }

                label {
                    color: #1884AF !important;
                }

                .ui.radio.checkbox .box:before,
                .ui.radio.checkbox label:before {
                    color: #1884AF !important;
                    border: 1px solid #1884AF !important;
                }

                .btn_enviar{
                    margin-top: 2em !important;
                    background-color: #1884AF !important;
                    color: #fff !important;
                    width: 100% !important
                }

                .label{
                    font-size: 1.5em !important;
                    text-align: center !important;
                    font-weight: 700 !important;
                }

                .content{
                    background-color: #E9E9E9 !important;
                    width: 100% !important;
                    padding: 1em 2em !important;
                    border-radius: 10px !important;
                    border: 1.5px solid #1884AF !important;
                    color: #1884AF !important;
                }

                .content_codparc{
                    margin: 2em auto !important;
                    font-weight: 700 !important;
                }

                .header{
                    margin-top: 0em !important;
                    border-radius: 0 0 10px  10px !important;
                    border-bottom: 1.5px solid #1884AF !important;
                }

                .header .header_menu{
                    width: 20% !important;
                    border-radius: .28571429rem 0 0 9px !important;
                    padding: .8em 1em !important;
                    background-color: #1884AF !important;
                    text-align: center !important;
                    color: #fff !important;
                }

                .container{
                    border:none !important;
                    padding: 0em !important;
                    width: 80% !important;
                    height: 100vh !important;
                    color: #fff !important;
                }

                @media (max-width: 590px ) {

                    .ui.grid>.row.formCupomLinhas{
                        
                        gap: 1em !important;
                        flex-direction: column !important;
                    }
                        
                    .ui.grid>.row.formCupomLinhas .column{
                        width: 100% !important;
                    }

                }

                @media (max-width: 768px) {
                    .header .header_menu{
                        width: 35% !important;
                    }
                }
                
            `}</style>
        </Segment>
    )
};


const mapStateToProps = (state) => ({
    vendedoresList: state.WhatsappReducer.vendedoresList,
    userid: state.LoginReducer.userid,
    codusu: state.LoginReducer.codusu,
    tipvend: state.LoginReducer.tipvend,
    codvend: state.LoginReducer.vendedorvcc,

    cupomDesconto: state.CupomReducer.cupomDesconto,
    cupomDescontoLoader: state.CupomReducer.cupomDescontoLoader,

    validarSenha: state.CupomReducer.validarSenha,
    validarSenhaLoader: state.CupomReducer.validarSenhaLoader,

})

export default withRouter(connect(mapStateToProps, {
    InsertCupomDescontoAction,
    ValidarSenhaAction
})(Relatorio));


